// 用于管理所有的状态，全局对象
import Vue from 'vue'
import Vuex from 'vuex'
import main from './modules/main'
import user from './modules/user'
import search from './modules/search'
import userInfo from './modules/userInfo'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    main,
    user,
    search,
    userInfo
  }
})
export default store
